import { ICorptaxTheme } from './ICorptaxTheme';
import { ISemanticStyleHelper } from './ISemanticStyleHelper';
import { CorptaxThemeSiteNavStyles } from './nav/CorptaxThemeSiteNavStyles';
import { ISemanticSiteNavStyles } from './nav/ISemanticSiteNavStyles';
import { CorptaxThemeSiteHeaderStyles } from './site-header/CorptaxThemeSiteHeaderStyles';
import { ISemanticSiteHeaderStyles } from './site-header/ISemanticSiteHeaderStyles';

export class CorptaxThemeStyles implements ISemanticStyleHelper {
    protected static siteHeaderHeight = 45;
    protected static fluentHeightPadding = 3;
    private _siteHeaderStyles: ISemanticSiteHeaderStyles;
    private _siteNavStyles: ISemanticSiteNavStyles;
    constructor(
        protected theme: ICorptaxTheme,
        siteHeaderStyles?: CorptaxThemeSiteHeaderStyles,
        siteNavStyles?: CorptaxThemeSiteNavStyles
    ) {
        this._siteHeaderStyles = siteHeaderStyles ?? new CorptaxThemeSiteHeaderStyles(this.theme, CorptaxThemeStyles.siteHeaderHeight);
        this._siteNavStyles =
            siteNavStyles ??
            new CorptaxThemeSiteNavStyles(this.theme, CorptaxThemeStyles.siteHeaderHeight + CorptaxThemeStyles.fluentHeightPadding);
    }
    get siteNavStyles(): ISemanticSiteNavStyles {
        return this._siteNavStyles;
    }
    get siteHeaderStyles(): ISemanticSiteHeaderStyles {
        return this._siteHeaderStyles;
    }
}
